import { getAdMarketPublishGroupCode } from './getCommonAdProperties';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';

export function isLgpdAdMarket() {
    const lgpdAdMarkets = [
        ...(isMiniFeatureEnabled('mini-ads-lgpd-canada') ? ['CA'] : []),
        'BR', // Brazil:  https://iapp.org/news/a/an-overview-of-brazils-lgpd/
        'CN', // China:  https://www.cookielawinfo.com/china-pipl/.
        'TR', // Turkey: https://www.dataguidance.com/notes/turkey-data-protection-overview.
    ];

    const marketPublishGroupCode = getAdMarketPublishGroupCode();
    const countryCode = marketPublishGroupCode.toUpperCase().split('-')[1];
    return lgpdAdMarkets.indexOf(countryCode) >= 0;
}
